module.exports = __webpack_public_path__ + "img/1185.854f5aa8.png";